<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-4>
    <!-- Stats Cards Section -->
    <v-row class="mb-3" no-gutters justify="start">
      <v-col class="pa-1">
        <v-card class="stats-card total-card" elevation="8">
          <v-card-text class="pa-2">
            <div class="text-center">
              <v-icon class="stats-icon mb-1" size="20" color="blue">mdi-account-group</v-icon>
              <div class="stats-label">TOTAL USERS</div>
              <div class="stats-value">{{ getTotalUsers }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-1">
        <v-card class="stats-card admin-card" elevation="8">
          <v-card-text class="pa-2">
            <div class="text-center">
              <v-icon class="stats-icon mb-1" size="20" color="green">mdi-shield-account</v-icon>
              <div class="stats-label">SUPER ADMIN</div>
              <div class="stats-value">{{ getSuperAdminCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-1">
        <v-card class="stats-card moderator-card" elevation="8">
          <v-card-text class="pa-2">
            <div class="text-center">
              <v-icon class="stats-icon mb-1" size="20" color="blue">mdi-account-cog</v-icon>
              <div class="stats-label">ADMIN</div>
              <div class="stats-value">{{ getAdminCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-1">
        <v-card class="stats-card volunteer-card" elevation="8">
          <v-card-text class="pa-2">
            <div class="text-center">
              <v-icon class="stats-icon mb-1" size="20" color="red">mdi-account-heart</v-icon>
              <div class="stats-label">VOLUNTEER</div>
              <div class="stats-value">{{ getVolunteerCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Fancy Filter Bar -->
    <v-card class="filter-bar mb-3" elevation="4">
      <v-card-text class="pa-2">
        <v-row align="center" no-gutters class="filter-row">
          <!-- Search Box -->
          <v-col cols="auto" class="pr-1">
            <v-text-field
              outlined
              dense
              background-color="white"
              placeholder="Search users..."
              prepend-inner-icon="mdi-magnify"
              class="fancy-input search-input"
              v-model="search"
              hide-details
              style="width: 250px;"
            ></v-text-field>
          </v-col>

          <!-- Role Filter -->
          <v-col cols="auto" class="pr-1">
            <v-autocomplete
              outlined
              dense
              background-color="white"
              label="Role"
              class="fancy-input filter-input"
              :items="['', 'SuperAdmin', 'Admin', 'Volunteer']"
              v-model="roleFilter"
              hide-details
              style="width: 140px;"
            ></v-autocomplete>
          </v-col>

          <!-- Action Buttons -->
          <v-col cols="auto" class="ml-auto">
            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    x-small
                    color="grey lighten-1"
                    class="mr-1"
                    @click="clearFilters()"
                    v-on="on"
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Clear Filters</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    x-small
                    color="purple lighten-1"
                    class="mr-1"
                    @click="add()"
                    v-on="on"
                  >
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add User</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    x-small
                    color="orange lighten-1"
                    class="mr-1"
                    @click="exporttoexcel()"
                    v-on="on"
                  >
                    <v-icon small>mdi-file-excel</v-icon>
                  </v-btn>
                </template>
                <span>Export to Excel</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    x-small
                    color="green lighten-1"
                    @click="refresh()"
                    v-on="on"
                  >
                    <v-icon small>mdi-autorenew</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      dense
      :headers="headers"
      :items-per-page="25"
      :items="filteredItems"
      :search="search"
      :loading="loading"
      :sort-by="['_id']"
      class="caption admin-table stylish-table"
      loading-text="Loading users... Please wait"
      no-data-text="No users found matching your criteria"
      fixed-header
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': 'Users per page:',
        'show-current-page': true,
        'show-first-last-page': true
      }"
    >

      <template v-slot:item.Edit-Delete="{ item }">
        <div class="d-flex align-center justify-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                x-small
                color="gradient-blue"
                class="fancy-edit-btn elevation-6 mr-1"
                @click="getrolebyid(item._id)"
                v-on="on"
                style="width: 24px; height: 24px;"
              >
                <v-icon x-small color="white">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit User</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                x-small
                color="red darken-1"
                class="fancy-delete-btn elevation-6"
                @click="deleterolebyid(item._id)"
                v-on="on"
                style="width: 24px; height: 24px;"
              >
                <v-icon x-small color="white">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete User</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.role="{ item }">
        <v-chip
          :class="getRoleClass(item.role)"
          class="custom-role-badge"
          small
          label
        >
          {{ item.role }}
        </v-chip>
      </template>

      <template v-slot:item._id="{ item }">
        <div class="user-index">
          {{ configdata.map(function(x) {return x._id; }).indexOf(item._id) + 1 }}
        </div>
      </template>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="popupbox" max-width="600px" hide-overlay>
        <v-toolbar color="light-green lighten-2" height="45">
          <v-toolbar-title class="body-2 elevation-0">Add/Edit Role</v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" v-model="valid" lazy-validation :close-on-content-click="false" :nudge-right="100" offset-y full-width min-width="500px">
          <v-card>
            <v-card-text>
              <div class="d-flex">
                <v-text-field ref="Json.firstname" outlined dense :rules="nameRules" class="caption mr-1" filled v-model="Json.firstname" label="Name" placeholder=" " height="25" required></v-text-field>
                <v-select ref="Json.role" outlined dense :rules="nameRules" class="caption mr-1" :items="['SuperAdmin', 'Admin', 'Volunteer']" filled v-model="Json.role" label="Role" placeholder=" " height="25" required></v-select>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.primaryemail" v-on:keyup="handleInputOnKeyup" outlined dense class="caption mr-1" filled v-model="Json.primaryemail" label="Primary Email" placeholder=" " height="25" required></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.createddate" outlined dense class="caption mr-1" filled v-model="Json.createddate" label="Created Date" disabled placeholder=" " height="25" required></v-text-field>
                <v-text-field ref="Json.updateddate" outlined dense class="caption mr-1" filled v-model="Json.updateddate" label="Updated Date" disabled placeholder=" " height="25" required></v-text-field>
              </div>
              <v-divider></v-divider>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline color="light-green lighten-3" @click="close">Close</v-btn>
              <v-btn  v-if="Json._id !== ''" small outline color="light-green lighten-3" @click="update" :disabled="!valid">Update</v-btn>
              <v-btn  v-if="Json._id === ''" small outline color="light-green lighten-3" @click="submit" :disabled="!valid">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="popup" persistent max-width="290">
        <v-card>
          <v-card-title class="body-2">Confirmation ?</v-card-title>
            <v-card-text>Are you sure want to delete</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="popup = false">NO</v-btn>
                <v-btn color="primary" text flat @click="confirmdeletion()">Confirm</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>

  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'
import XLSX from 'xlsx'

export default {
  data () {
    return {
      search: '',
      roleFilter: '',
      loading: false,
      configdata: [],
      headers: [
        {text: '#', align: 'left', value: '_id', class: "font-weight-black indigo lighten-5 black--text", divider: true},
        {text: 'Name', align: 'left', value: 'firstname', class: "font-weight-black indigo lighten-5 black--text", divider: true},
        {text: 'Primary Email', align: 'left', value: 'primaryemail',class: "font-weight-black indigo lighten-5 black--text", divider: true},
        {text: 'Role', align: 'left', value: 'role', class: "font-weight-black indigo lighten-5 black--text", divider: true},
        {text: 'CreatedDate', align: 'left', value: 'createddate', class: "font-weight-black indigo lighten-5 black--text", divider: true},
        {text: 'UpdatedDate', align: 'left', value: 'updateddate', class: "font-weight-black indigo lighten-5 black--text", divider: true},
        {text: 'Edit-Delete', align: 'left', value: 'Edit-Delete', class: "font-weight-black indigo lighten-5 black--text", divider: true},
      ],
      Json: {
        _id: '',
        firstname: '',
        primaryemail: '',
        role: '',
        createddate: '',
        updateddate: ''
      },
      select: null,
      valid: true,
      name: '',
      nameRules: [v => !!v || 'This Field is required'],
      comment: null,
      popupbox: false,
      popup: false
    }
  },
  computed: {
    filteredItems () {
      return this.configdata.filter(i => {
        const roleMatch = this.roleFilter ? i.role === this.roleFilter : true;
        return i.role && roleMatch;
      })
    },
    getTotalUsers () {
      return this.configdata.length;
    },
    getSuperAdminCount () {
      return this.configdata.filter(user => user.role === 'SuperAdmin').length;
    },
    getAdminCount () {
      return this.configdata.filter(user => user.role === 'Admin').length;
    },
    getVolunteerCount () {
      return this.configdata.filter(user => user.role === 'Volunteer').length;
    }
  },
  methods: {
    handleInputOnKeyup() {
      this.Json.primaryemail = this.Json.primaryemail.toLowerCase().trim()
    },
    logoutFromFirebase () {
      this.$store.dispatch('signOutAction')
      .then(() => this.$router.replace('/Signin'))
    },
    exporttoexcel () {
      var rolemasterdata = XLSX.utils.json_to_sheet(this.configdata) 
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, rolemasterdata, 'rolemasterdata')
      XLSX.writeFile(wb, 'rolemasterdata.xlsx')
    },
    getColor (status) {
      if (status === 'Admin') return 'blue'
      else if (status === 'SuperAdmin') return 'green'
      else if (status === 'Organizer') return 'indigo'
      else if (status === 'Volunteer') return 'red'
      else return 'red'
    },
    getRoleClass(role) {
      if (role === 'SuperAdmin') return 'role-superadmin'
      else if (role === 'Admin') return 'role-admin'
      else if (role === 'Volunteer') return 'role-volunteer'
      else return 'role-default'
    },
    clearFilters() {
      this.search = '';
      this.roleFilter = '';
    },
    async cleardata () {
        this.Json._id = ''
        this.Json.firstname = ''
        this.Json.primaryemail = ''
        this.Json.role = ''
        this.Json.createddate = ''
        this.Json.updateddate = ''
    },
    async getrolebyid (id) {
      if (id) {
        this.popupbox = true
        this.roleData = (await ReportServices.getrolebyid(id)).data
        this.Json._id = this.roleData._id
        this.Json.firstname = this.roleData.firstname
        this.Json.primaryemail = this.roleData.primaryemail
        this.Json.role = this.roleData.role
        this.Json.createddate = this.roleData.createddate
        this.Json.updateddate = this.roleData.updateddate
      }
    },
    async deleterolebyid (id) {
      this.popup = true
      this.id=id
    },
    async add () {
      this.popupbox = true
      this.cleardata ()
    },
    async submit () {
      if (this.$refs.form.validate()) {
        ReportServices.addrole(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 400)
      }
    },
    update () {
      if (this.$refs.form.validate()) {
        ReportServices.updaterole(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 400)
      }
    },
    confirmdeletion () {
      ReportServices.deleterole(this.id)
      this.popup = false
      setTimeout(() => {
         this.refresh()
      }, 400)
    },
    async refresh () {
      this.loading = true
      this.configdata = (await ReportServices.getConfigData()).data
      this.loading = false
      this.noDataText = 'No data available'
    },
    close () {
      this.popupbox = false
    }
  },
  async mounted () {
    this.refresh()
  }
}
</script>
<style lang="scss">
  * {
    box-sizing: border-box;
    text-transform: none;
  }

  /* Enhanced Data Table Styling */
  .admin-table {
    border-radius: 12px !important;
    overflow: hidden !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
    background: white !important;
  }

  .admin-table .v-data-table {
    border: none !important;
    border-radius: 12px !important;
  }

  .admin-table .v-data-table__wrapper {
    border: none !important;
    border-radius: 12px !important;
  }

  /* Modern Header Styling */
  .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
    font-weight: 700 !important;
    border-right: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-bottom: none !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    font-size: 12px !important;
    padding: 16px 12px !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 2 !important;
  }

  .theme--light.v-data-table.v-data-table--fixed-header thead th:first-child {
    border-left: none !important;
  }

  .theme--light.v-data-table.v-data-table--fixed-header thead th:last-child {
    border-right: none !important;
  }

  /* Alternate Row Colors */
  .admin-table .v-data-table tbody tr:nth-child(odd) {
    background-color: #f8f9fa !important;
  }

  .admin-table .v-data-table tbody tr:nth-child(even) {
    background-color: #ffffff !important;
  }

  /* Row Hover Effects */
  .admin-table .v-data-table tbody tr:hover {
    background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;
  }

  /* Cell Styling */
  .admin-table .v-data-table tbody td {
    border-bottom: 1px solid #e0e0e0 !important;
    padding: 12px !important;
    font-size: 13px !important;
    color: #424242 !important;
    vertical-align: middle !important;
  }

  /* Remove default table borders */
  table {
    border: none !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .w-100 {
    width: 100%
  }

  /* Custom Role Badge Styling */
  .custom-role-badge {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
    transition: all 0.2s ease !important;
    cursor: default !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
  }

  .custom-role-badge:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
    transform: translateY(-1px) !important;
  }

  /* Role-specific styling */
  .role-superadmin {
    background-color: #4CAF50 !important; /* Green */
    color: white !important;
  }

  .role-admin {
    background-color: #2196F3 !important; /* Blue */
    color: white !important;
  }

  .role-volunteer {
    background-color: #FF5722 !important; /* Red */
    color: white !important;
  }

  .role-default {
    background-color: #FF9800 !important; /* Orange */
    color: white !important;
  }

  /* User Index Styling */
  .user-index {
    font-weight: 600 !important;
    color: #666 !important;
    text-align: center !important;
  }

  /* Fancy Stats Cards */
  .stats-card {
    border-radius: 12px !important;
    transition: all 0.3s ease !important;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    backdrop-filter: blur(10px) !important;
    height: 100% !important;
    min-height: 70px !important;
    max-width: 180px !important;
    min-width: 160px !important;
    margin: 0 !important;
  }

  .stats-card:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
  }

  .stats-icon {
    background: rgba(255, 255, 255, 0.2) !important;
    border-radius: 50% !important;
    padding: 4px !important;
    backdrop-filter: blur(10px) !important;
  }

  .stats-label {
    font-size: 10px !important;
    font-weight: 600 !important;
    color: #4a5568 !important;
    margin-bottom: 2px !important;
    letter-spacing: 0.5px !important;
  }

  .stats-value {
    font-size: 18px !important;
    font-weight: 700 !important;
    color: #2d3748 !important;
    line-height: 1 !important;
  }

  /* Card-specific gradients */
  .total-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  }

  .total-card .stats-label,
  .total-card .stats-value {
    color: white !important;
  }

  .admin-card {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%) !important;
  }

  .admin-card .stats-label,
  .admin-card .stats-value {
    color: white !important;
  }

  .moderator-card {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%) !important;
  }

  .volunteer-card {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%) !important;
  }

  /* Filter Bar Styling */
  .filter-bar {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
    border-radius: 12px !important;
    border: 1px solid #dee2e6 !important;
  }

  .filter-row {
    gap: 8px !important;
  }

  .fancy-input {
    border-radius: 8px !important;
  }

  .fancy-input .v-input__control .v-input__slot {
    border-radius: 8px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;
  }

  .fancy-input .v-input__control .v-input__slot:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  }

  .fancy-input.v-input--is-focused .v-input__control .v-input__slot {
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
    border-color: #667eea !important;
  }

  /* Action Button Styling */
  .fancy-edit-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    transition: all 0.2s ease !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
  }

  .fancy-edit-btn:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
  }

  .fancy-delete-btn {
    transition: all 0.2s ease !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
  }

  .fancy-delete-btn:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4) !important;
  }

  /* Icon sizing for action buttons */
  .fancy-edit-btn .v-icon,
  .fancy-delete-btn .v-icon {
    font-size: 14px !important;
  }

  /* Enhanced Data Table Footer/Pagination */
  .admin-table .v-data-footer {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
    border-top: 1px solid #dee2e6 !important;
    border-radius: 0 0 12px 12px !important;
    padding: 8px 16px !important;
  }

  .admin-table .v-data-footer__select .v-select {
    margin: 0 !important;
  }

  .admin-table .v-data-footer__pagination {
    margin: 0 !important;
  }

  /* Loading State Styling */
  .admin-table .v-data-table__progress {
    background: linear-gradient(90deg, #667eea, #764ba2, #667eea) !important;
    background-size: 200% 100% !important;
    animation: shimmer 1.5s infinite !important;
  }

  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  /* Table Animation on Load */
  .stylish-table {
    animation: fadeInUp 0.6s ease-out !important;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Row Animation */
  .admin-table .v-data-table tbody tr {
    animation: slideInLeft 0.3s ease-out !important;
    animation-fill-mode: both !important;
  }

  .admin-table .v-data-table tbody tr:nth-child(1) { animation-delay: 0.1s !important; }
  .admin-table .v-data-table tbody tr:nth-child(2) { animation-delay: 0.15s !important; }
  .admin-table .v-data-table tbody tr:nth-child(3) { animation-delay: 0.2s !important; }
  .admin-table .v-data-table tbody tr:nth-child(4) { animation-delay: 0.25s !important; }
  .admin-table .v-data-table tbody tr:nth-child(5) { animation-delay: 0.3s !important; }

  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* Responsive adjustments */
  @media (max-width: 1200px) {
    .stats-card {
      min-height: 65px !important;
      max-width: 150px !important;
      min-width: 130px !important;
    }

    .stats-value {
      font-size: 16px !important;
    }

    .stats-label {
      font-size: 8px !important;
    }
  }

  @media (max-width: 960px) {
    .stats-card {
      min-height: 60px !important;
      max-width: 120px !important;
      min-width: 100px !important;
    }

    .stats-value {
      font-size: 14px !important;
    }

    .stats-label {
      font-size: 7px !important;
    }

    .stats-icon {
      size: 16px !important;
    }

    .filter-row {
      flex-direction: column !important;
      gap: 12px !important;
    }

    .filter-input {
      width: 100% !important;
    }
  }

  @media (max-width: 600px) {
    .stats-card {
      min-height: 50px !important;
      max-width: 100px !important;
      min-width: 80px !important;
    }

    .stats-value {
      font-size: 12px !important;
    }

    .stats-label {
      font-size: 6px !important;
    }
  }

  /* Dialog Styling Updates */
  .v-dialog .v-card {
    border-radius: 12px !important;
  }

  .v-toolbar {
    border-radius: 12px 12px 0 0 !important;
  }

  /* Form Field Styling */
  .v-text-field--outlined .v-input__control .v-input__slot {
    border-radius: 8px !important;
  }

  .v-select--outlined .v-input__control .v-input__slot {
    border-radius: 8px !important;
  }

  .v-autocomplete--outlined .v-input__control .v-input__slot {
    border-radius: 8px !important;
  }
</style>